import styled from 'styled-components';

export const Portal = styled.div`
  display: none;
`;
